var path = 'pages/fund/thankyou.html';
var html = "<div class=post id=fundView-thankYou> <i class=\"fa fa-heart fa-5x\" id=fundView-thankyouIcon></i> <h1 id=fundView-heading data-i18n=views.fund.thanks.heading></h1> <p data-i18n=views.fund.thanks.content> </p> <a whispeer-sref=app.main class=\"btn btn--primary btn--big\"><i class=\"fa fa-home fa-3x fa-fw\" id=fundView-home></i> <span data-i18n=views.fund.thanks.back></span></a> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./views/pages/fund/thankyou.html
// module id = K8xb
// module chunks = 1